<!-- 创建商品 -->
<template>
	<div class="bg-white px-3 goods_create" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{name:'zlgl_cpzl_cpgl'}" style="position: absolute;top: 32px;left: 200px;">
			<el-button size="mini">回到货物资料</el-button>
		</router-link>
		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 67%;">
					<el-form-item label="货物名称">
						<el-input v-model="lists.name" style="width: 95%;" size="mini"></el-input>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="编号">
						<el-input v-model="lists.bh" style="width: 90%;" size="mini" :disabled="true"></el-input>
						
					</el-form-item>
				</div>
			</div>
			<div class="d-flex">
				<div style="width: 34%;">
					<el-form-item label="重量">
						<el-input-number v-model="lists.zl" size="mini" style="width: 90%;"></el-input-number>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="面积">
						<el-input-number v-model="lists.mj" size="mini" style="width: 90%;" :precision="2"></el-input-number>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="体积">
						<el-input-number v-model="lists.tj" size="mini" style="width: 90%;" :precision="2"></el-input-number>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<el-button type="primary" style="position: fixed;bottom: 50px;right: 50px;" @click="submit">提交</el-button>

	</div>
</template>

<script>
	import tinymce from '@/components/common/tinymce.vue'; // 引入 富文本 组件
	import { mapState } from 'vuex'; // 引入 全局 公共数据
	export default {
		inject: ['app', 'layout'],
		components: {
			tinymce
		},
		data() {
			return {
				lists:{},
			}
		},
		computed: {
			// 引入store-modules的user模块里面的user(存储用户相关的数据)
			...mapState({
				user: state => state.user.user,
			}),
		},
		// 生命周期
		created() {
			this.lists = this.$route.params.data
			this.axios.get('/admin/cpdws',{ token:true }).then(res=>{
				this.jldws = res.data.data
			})
		},
		methods: {

			chooseImage() {
				this.app.chooseImage((res) => {
					this.lists.cptp = res[0].url
				}, 1)
			},
			
			//提交
			submit() {
				this.layout.showLoading()
				console.log(this.lists.id)
				let url = this.lists.id ? '/admin/cpgl/' + this.lists.id : '/admin/cpgl'
				this.axios.post(url, this.lists, {
					token: true
				}).then(res => {
					if(res.data.data == 'ok'){
						this.$message({
							type: "success",
							message: this.id ? "修改成功" : "添加成功"
						})
						this.$router.push({
							name: "zlgl_cpzl_cpgl"
						})
					}else{
						this.$message({
							type: "warning",
							message: res.data.data
						})
					}
					
					this.layout.hideLoading()
				}).catch(err => {
					this.layout.hideLoading()
				})
			}
		},
	}
</script>

<style>
	.goods_create .el-form-item {
		margin-bottom: 15px;
	}
	.pt-a{
		padding-top: 20px;
	}
</style>
